import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getLeaderboardBanner} from '../../../apis/banner/getLeaderboardBanner'

const PAGE_SIZE = 30
const useQueryLeaderboardBanner = currentPage => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.advertisement.getLeaderboardBanner(),
        queryFn: async () => {
            const {data, pageInfo} = await getLeaderboardBanner(PAGE_SIZE, currentPage)
            return {data, pageInfo}
        },
        refetchOnWindowFocus: false,
    })

    return {data: data?.data, pageInfo: data?.pageInfo, refetch}
}

export default useQueryLeaderboardBanner
